var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Button } from "../../../button";
import { Typo } from "../../../typography";
import { useFocusVisible } from "use-focus-visible";
import { FormField } from "../../../form";
import { StyledMaskInput, StyledDateInputWithIcon } from "./date-input.styles";
export const Input = (_a) => {
    var _b;
    var { onFocus, onBlur, onClick, onIconClick, onReset, onChange, onValueChange, value, label, withIcon, error, show, readonly, disabled, isRangePicker, required } = _a, props = __rest(_a, ["onFocus", "onBlur", "onClick", "onIconClick", "onReset", "onChange", "onValueChange", "value", "label", "withIcon", "error", "show", "readonly", "disabled", "isRangePicker", "required"]);
    const [selected, setSelected] = useState(false);
    const [val, setVal] = useState(value);
    const { focusVisible, onFocus: onFocused, onBlur: onBlured, } = useFocusVisible();
    const myRef = useRef(null);
    const activeElement = typeof window !== "undefined" ? document.activeElement : null;
    useEffect(() => {
        setVal(value);
    }, [value]);
    useEffect(() => {
        if (!myRef.current)
            return () => { };
        const button = myRef.current.querySelector("button");
        if (button) {
            const handler = () => {
                setSelected(false);
            };
            button.addEventListener("blur", handler);
            return () => {
                button.removeEventListener("blur", handler);
            };
        }
        return () => { };
    }, [activeElement]);
    useEffect(() => {
        if (!myRef.current)
            return () => { };
        setSelected(myRef.current.contains(activeElement));
        const input = myRef.current.querySelector("input");
        if (input) {
            const clickHandler = () => {
                if (!input)
                    return;
                const { length } = input.value.replace(/\D+$/g, "");
                input.setSelectionRange(length, length);
            };
            input.addEventListener("click", clickHandler);
            return () => {
                input.removeEventListener("click", clickHandler);
            };
        }
    }, [activeElement]);
    useEffect(() => {
        if (show) {
            setSelected(true);
        }
    }, [show]);
    if (readonly || disabled) {
        return (_jsx(FormField, Object.assign({}, props, { label: label, readOnly: readonly, disabled: disabled, name: "readonlyField", values: { readonlyField: String(val) } })));
    }
    return (_jsxs(StyledDateInputWithIcon, Object.assign({ withLabel: !!label, ref: myRef }, { children: [label && (_jsxs(Typo, Object.assign({ variant: "label2" }, { children: [label, label && required && "*"] }))), _jsx(StyledMaskInput, Object.assign({}, props, { "$error": error, value: val, "$show": show, "$isRangePicker": isRangePicker, onChange: (e) => {
                    if (typeof onChange === "function")
                        onChange(e);
                    setVal(e.target.value);
                }, onValueChange: (p) => {
                    if (typeof onValueChange === "function") {
                        onValueChange(p);
                    }
                    setVal(p.value);
                }, "$selected": selected, "$focusVisible": focusVisible, onBlur: (e) => {
                    if (typeof onBlur === "function")
                        onBlur(e);
                    onBlured();
                }, onFocus: (e) => {
                    if (typeof onFocus === "function")
                        onFocus(e);
                    setSelected(true);
                    onFocused();
                }, size: (_b = props.mask) === null || _b === void 0 ? void 0 : _b.length, onClick: onClick })), error && (_jsx(Typo, Object.assign({ className: "error-msg", variant: "label2" }, { children: error }))), withIcon ? (val && !isRangePicker ? (_jsx(Button, { stylingType: "flat", onClick: () => {
                    setVal("");
                    if (typeof onReset === "function")
                        onReset();
                }, isIcon: true, symbol: "Close" })) : (_jsx(Button, { stylingType: "flat", onClick: () => {
                    if (typeof onIconClick === "function")
                        onIconClick();
                }, isIcon: true, symbol: "Calendar" }))) : (val && (_jsx(Button, { stylingType: "flat", onClick: () => {
                    var _a;
                    const input = (_a = myRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("input");
                    setVal("");
                    onFocused();
                    input === null || input === void 0 ? void 0 : input.focus();
                    setTimeout(() => {
                        input === null || input === void 0 ? void 0 : input.setSelectionRange(0, 0);
                    }, 0);
                    if (typeof onReset === "function")
                        onReset();
                }, isIcon: true, symbol: "Close" })))] })));
};
